import { getAssignedAgent, getAssignedAgentId
// @ts-expect-error module not typed
} from 'conversations-message-history/assignment-update-message/operators/assignmentGetters';
import { AI } from 'conversations-message-history/common-message-format/constants/agentTypes';
import { Map as ImmutableMap } from 'immutable';
// @ts-expect-error module not typed

import get from 'transmute/get';
const getIsCustomerAgentActorId = assignedActorId => {
  return !!(assignedActorId !== null && assignedActorId !== void 0 && assignedActorId.startsWith('L'));
};
export const getAssigneeFromAssignmentUpdateMessage = message => {
  const assignedActorId = get('assignedActorId', message);
  if (getIsCustomerAgentActorId(assignedActorId)) {
    return ImmutableMap({
      agentType: AI,
      agentId: getAssignedAgentId(message)
    });
  }
  const assignedAgent = getAssignedAgent(message);
  return assignedAgent ? ImmutableMap(assignedAgent) : null;
};